/* Sticky Jams cart drawer — upsell "+ Add" (always-bound, delegated). */
(function () {
  if (window.__sjCartInit) return;
  window.__sjCartInit = true;

  function refreshDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (data.sections && data.sections['cart-drawer'] && drawer) {
      var tmp = document.createElement('div');
      tmp.innerHTML = data.sections['cart-drawer'];
      var ni = tmp.querySelector('.drawer__inner');
      var ci = drawer.querySelector('.drawer__inner');
      if (ni && ci) ci.replaceWith(ni);
      drawer.classList.remove('is-empty');
    }
    try {
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
        var s = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
        if (s && data.item_count != null) s.textContent = data.item_count;
      });
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sj-upsell-add');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { btn.disabled = false; return; }
        refreshDrawer(data);
      })
      .catch(function () { btn.disabled = false; });
  });
})();
